<script setup lang="ts">
import { computed } from 'vue'
import VueApexCharts from 'vue3-apexcharts'
import { useUiStore } from '@/stores/ui'

const props = defineProps<{
    values: number[]
}>()

const ui = useUiStore()

const options = computed(() => ({
    chart: { type: 'area' as const, sparkline: { enabled: true }, animations: { enabled: false } },
    stroke: { curve: 'smooth' as const, width: 2 },
    fill: { type: 'gradient', gradient: { shadeIntensity: 1, opacityFrom: 0.45, opacityTo: 0.05 } },
    // Brighter teal in dark mode for contrast against dark surface.
    colors: [ui.resolvedTheme === 'dark' ? '#2dd4bf' : '#0d9488'],
    tooltip: { enabled: false }
}))

const series = computed(() => [{ data: props.values }])
</script>

<template>
    <VueApexCharts type="area" height="40" :options="options" :series="series" />
</template>
